export const ENV_PRODUCTION = 'production'

export const FIXED = 'fixed'
export const NOT_FIXED = 'notFixed'
export const BRAND_EXETEL = 'exetel'

export const SERVICE_NBN = 'nbn'
export const SERVICE_FIBRE = 'fibre'
export const SERVICE_WIRELESS = 'hwbb'
export const SERVICE_ADSL = 'adsl'
export const SERVICE_MOBILE = 'mobile'
export const SERVICE_MOBILE_BROADBAND = 'mbb'
export const SERVICE_VOIP = 'voip'
export const SERVICE_PSTN = 'pstn'
export const SERVICE_HOME_SECURE = 'homeSecure'
export const SERVICE_SPEED_BOOST = 'speedBoost'

export const ALL_SERVICES = [SERVICE_ADSL, SERVICE_FIBRE, SERVICE_MOBILE, SERVICE_MOBILE_BROADBAND, SERVICE_NBN, SERVICE_WIRELESS, SERVICE_VOIP, SERVICE_PSTN]

export const VOIP_PAYG = 'payAsYouGo'
export const VOIP_UNLIMITED = 'unlimited'

export const ACTION_ADD = 'add'
export const ACTION_MODIFY = 'modify'
export const ACTION_DELETE = 'delete'

export const IS_HTML = '{{IS_HTML}}'

export const TYPE_ALLOWED = 'allowed'
export const TYPE_BLOCKED = 'blocked'

export const NETWORK_TELSTRA = 'Telstra'
export const NETWORK_OPTUS = 'Optus'

export const MFA_SMS = 'MfaOverSMS';
export const MFA_EMAIL = 'MfaOverEmail';

export const mapServiceTypeToTitle = {
    [SERVICE_NBN]: 'nbn&trade;',
    [SERVICE_FIBRE]: 'Fibre',
    [SERVICE_WIRELESS]: 'Home Wireless Broadband',
    [SERVICE_ADSL]: 'ADSL',
    [SERVICE_MOBILE]: 'Mobile',
    [SERVICE_MOBILE_BROADBAND]: 'Mobile Broadband',
    [SERVICE_VOIP]: 'Home Phone',
    [SERVICE_PSTN]: 'Home Phone (PSTN)',
    [SERVICE_HOME_SECURE]: 'Home Secure',
    [SERVICE_SPEED_BOOST]: 'My Speed Boost'
}

export const MAP_SERVICE_TYPE = {
    ["mobile"]: 'Mobile',
    ["sim"]: "Sim"
}

export const mapTidyUsageNames = {
    Calls: 'National calls',
    SMS: 'National SMS',
    Intl: 'International calls',
    'Calls&SMS': 'National calls & SMS'
}

export const mapCisToType = {
    [SERVICE_NBN]: 'https://files.exetel.com.au/cis/nbn/2024-07/Exete_CIS_NBN_Broadband.pdf',
    [SERVICE_FIBRE]: 'https://files.exetel.com.au/cis/fibre/2024-07/Exetel_CIS_Fibre_Broadband.pdf',
    [SERVICE_ADSL]: 'https://files.exetel.com.au/cis/190725/adsl/CIS_ADSL_Bundle_OW.pdf'
}

export const mapTermsToType = {
    [SERVICE_NBN]: 'https://www.exetel.com.au/broadband/nbn/terms',
    [SERVICE_FIBRE]: 'https://www.exetel.com.au/broadband/fibre/terms'
}

export const mapKeyFactsToType = {
    [SERVICE_NBN]: 'https://files.exetel.com.au/terms/NBN_Key_Facts_Sheet.pdf',
    [SERVICE_FIBRE]: 'https://files.exetel.com.au/terms/Fibre_Key_Facts_Sheet.pdf'
}

export const mapTitleFields = [
    { value: 'Mr', label: 'Mr' },
    { value: 'Mrs', label: 'Mrs' },
    { value: 'Ms', label: 'Ms' },
    { value: 'Miss', label: 'Miss' },
    { value: 'Dr', label: 'Dr' }
]

export const idStates = ['NSW', 'VIC', 'QLD', 'ACT', 'NT', 'WA', 'SA', 'TAS']

export const TYPE_PREPAID = 'prePaid'
export const TYPE_POSTPAID = 'postPaid'

export const providers = [
    'AAPT',
    'Accounts Choice',
    'ACN',
    'Activ8me',
    'Adam Internet',
    'ALDImobile',
    'Amaysim',
    'Apex Telecom',
    'Austar',
    'BDigital',
    'Bell Networks',
    'Belong',
    'Bendigo Bank Telco',
    'Blink',
    'Boost Mobile',
    'BT Telecom',
    'Bureau Holdings',
    'Cellhire',
    'Charitel',
    'ClubTelco',
    'CMobile',
    'Coles Mobile',
    'Commander',
    'Comms Choice',
    'Community Telco',
    'Connex',
    'Crazy Johns',
    'CTExcelbiz',
    'Dodo',
    'Down Under Communica',
    'E.Tel',
    'Engin',
    'Excite Mobile',
    'Exetel',
    'Flexirent',
    'Global Gossip',
    'Global Mobility Grou',
    'GoTalk',
    'GTMobile',
    'Hello Mobile',
    'Hutchison3',
    'iiNet',
    'Internode',
    'iPrimus',
    'iSeek',
    'ISPOne',
    'iTalkBB',
    'Jeenee Mobile',
    'Just Mobile',
    'Kidney Australia',
    'KISA Phone',
    'Kiss Mobile',
    'Kogan Mobile',
    'Lebara Mobile',
    'Live Connected',
    'Lycamobile',
    'M2 Telecom',
    'Macquarie Telecom',
    'MATE',
    'MyNetFone',
    'Neptune',
    'ONEmobile',
    'OneSeniors',
    'Optus Post Paid',
    'Optus PrePaid',
    'Oracle Telecom',
    'Pacnet',
    'PennyTel',
    'People Telecom',
    'Perfection Telecom',
    'PhoneStar/Spa',
    'Planet Mobile',
    'Primus Telecom',
    'Quality Telecom',
    'RealSIM',
    'Red Bull Mobile',
    'Revolution Telecom',
    'Reward Mobile',
    'Savvytel',
    'SlimTel',
    'Soul',
    'Southern Cross Telco',
    'Southern Phone',
    'SpinTel',
    'Startel',
    'Sure Telecom',
    'Switched On',
    'Switchtelco',
    'Telair',
    'Telarus',
    'Telco Green',
    'Telco In A Box',
    'Telco4U',
    'TeleChoice',
    'Telstra',
    'Think Mobile',
    'TPG',
    'TransACT',
    'Truphone',
    'Ugly Bill',
    'untimedmobiles.com.a',
    'Vaya',
    'Virgin Mobile',
    'Vodafone',
    'Westnet',
    'Woolworths Connect',
    'Yatango Mobile'
]

export const SIM_TYPE_3IN1 = 1291
export const SIM_TYPE_ESIM = 1325
export const SIM_ESIM = 'ESIM'
export const STATUS_PENDING = 'pending'
export const STATUS_COMPLETE = 'complete'
export const STATUS_ERROR = 'error'
export const STATUS_VALIDATE = 'validate'

export const PROGRESS_SIM_ACTIVATED = 'serviceActive'
export const PROGRESS_SIM_ACTIVATE = 'simActivate'
export const PROGRESS_SERVICE_ACTIVE = 'serviceActive'
export const PROGRESS_SETUP_MODEM = 'setupModem'
export const PROGRESS_TRACK_MODEM = 'trackModem'
export const PROGRESS_NBN_TECHNICIAN = 'nbnTechnician'
export const PROGRESS_NBN_TECHNICIAN_APPOINTMENT = 'technicianAppointment'
export const PROGRESS_NBN_MISSED = 'nbnMissedTechnician'

export const EXETEL_URL = 'https://www.exetel.com.au'
export const APP_ANDROID = 'https://play.google.com/store/apps/details?id=com.exetel.app&p'
export const APP_IOS = 'https://apps.apple.com/au/app/exetel/id6474650965'


// WEBPACK FOOTER //
// ./resources/js/constants.js